var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "product-update-box d-flex align-items-center" },
    [
      _c("span", { staticClass: "mdi mdi-history", class: _vm.outdated }),
      _c("span", { staticClass: "ml-1", class: _vm.outdated }, [
        _vm._v(_vm._s(_vm.value)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }